import { ArrowUpRight } from "lucide-react";
import { DIRECTORY } from "@/data/tools";
import { Reveal } from "@/components/Reveal";

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const PartnerLinks = () => (
  <section id="partner-links" aria-labelledby="partner-links-title" className="pb-24 lg:pb-36" data-testid="partner-links">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-10">
      <Reveal className="mb-10 max-w-2xl">
        <p className="eyebrow mb-4">Partner links</p>
        <h2 id="partner-links-title" className="font-display text-4xl font-medium leading-[1.02] tracking-[-0.02em] sm:text-5xl">
          More from the <span className="italic text-brand">project</span>
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink-soft sm:text-lg">Partner sites open in a new tab.</p>
      </Reveal>
      <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {DIRECTORY.filter((d) => d.url).map((d, i) => (
          <Reveal as="li" key={d.name} delay={i * 0.06}>
            <a href={`https://${d.url}`} target="_blank" rel="noopener noreferrer" data-testid={`partner-${slug(d.name)}`}
              className="group flex h-full flex-col rounded-[1.5rem] border-2 border-line bg-surface p-6 transition-colors duration-300 hover:border-brand">
              <span className="font-display text-2xl font-medium">{d.name}</span>
              <span className="mt-2 flex-1 text-sm text-ink-soft">{d.desc}</span>
              <span className="mt-5 inline-flex items-center gap-1.5 break-all text-sm font-bold text-brand">
                {d.url} <ArrowUpRight size={16} className="shrink-0 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden />
                <span className="sr-only">(opens in a new tab)</span>
              </span>
            </a>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
